<script setup lang="ts">
import ProductCatalog from "~/components/products/ProductCatalog.vue";

const route = useRoute();
const categorySlug = computed(() => String(route.params.category_slug));
</script>

<template>
  <ProductCatalog :key="categorySlug" :category-slug="categorySlug" />
</template>
